import $ from "jquery";
import {debounce} from "lodash/function";
import {chunk} from "lodash/array";

let cards_blocs = null;

/**
 * Si il y a des bloc de type "Features Grid" on doit calculer la même hauteur pour chaque ligne de features
 */
const init_cards_blocs_same_height = () => {
    cards_blocs =  $(".card-same-height-bloc");
    if (cards_blocs.length > 0) {
        const $cards_images = cards_blocs.find('.card .card-image img');
        $cards_images.one("load", function() {
            resize_windows()
        }).each(function() {
            if(this.complete) {
                $(this).trigger('load');
            }
        });
        $(window).on('resize', debounce(resize_windows, 150));
        resize_windows();
    }
}

/**
 * Handler déclenché sur le resize de la windows
 */
const resize_windows = () => {
    cards_blocs.each((index, el) => {
        const nb_cards = $(el).find('.card')
        if (nb_cards.length > 1) {
            calc_row_at_same_height($(el))
        }
    });

}

/**
 * Calcul de la même hauteur de feature pour chaque nouvelle ligne
 * @param $el
 */
const calc_row_at_same_height = ($el) => {
    const $container = $el.children('.container');
    const maxWidthContainer = parseInt($container.css('maxWidth'), 10);
    const $cards_arr = $container.find('.card');

    //delete fixed height
    $cards_arr.each((index, single_feature) => {
        $(single_feature).css('height', '');
    });

    if (!isNaN(maxWidthContainer)) {
        switch (ajax_data.container_with[maxWidthContainer]) {
            case 'sm' :
            case 'md' :
                resize_by_number_in_row(2, $cards_arr);
                break;
            case 'lg' :
                resize_by_number_in_row(3, $cards_arr);
            case 'xl' :
            case 'xxl' :
                if($el.hasClass('force_display_by_five')){
                    resize_by_number_in_row(5, $cards_arr);
                }else{
                    resize_by_number_in_row(3, $cards_arr);

                }
                break;
            default:
                return;
        }
    }

}

const resize_by_number_in_row = (numberInRow, features) => {
    const chunks = chunk(features, numberInRow);
    chunks.forEach((features_line) => {
        if (features_line.length > 1) {
            resize_single_row(features_line);
        }
    })
}

const resize_single_row = (row) => {
    let maxHeight = 0;

    row.forEach((single_feature) => {
        const $feature = $(single_feature);
        let featureHeight = $feature.outerHeight();
        if (featureHeight > maxHeight) {
            maxHeight = featureHeight;
        }
    })
    row.forEach((single_feature) => {
        // On met les cards à la même hauteur
        $(single_feature).css('height', maxHeight);
        const $additionalLinks = $(single_feature).find('ul.add_links');
        if($additionalLinks.length > 0){
            const innerHeight = $(single_feature).find(".inner").height();
            const contentWithoutAddLinksListHeight = $(single_feature).find(".inner .card-without-add-link").height();
            const remainingSpace = innerHeight - contentWithoutAddLinksListHeight;
            const addLinksListHeight = $additionalLinks.height();
            if(remainingSpace > addLinksListHeight + 32){ //32 = margintop de la liste
                const diff = remainingSpace - addLinksListHeight;
                $additionalLinks.css('marginTop', diff);
            }
        }
    });
}

export {init_cards_blocs_same_height}